module.exports = __webpack_public_path__ + "img/co2.ab616720.svg";